/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  START_TIMER,
  STOP_TIMER,
} from 'src/actions/digitalDispatchTimerActions';

const initialState = {
  isTimerTriggered: false,
  dispatchId: null,
  timerDuration: null,
};

// eslint-disable-next-line default-param-last
const digitalDispatchTimerReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_TIMER: {
      const dispatchId = action.payload?.dispatchId;
      return produce(state, (draft) => {
        draft.isTimerTriggered = true;
        draft.dispatchId = dispatchId;
        draft.timerDuration = action.payload?.timerDuration;
      });
    }
    case STOP_TIMER: {
      return produce(state, (draft) => {
        draft.isTimerTriggered = false;
        draft.dispatchId = null;
        draft.timerDuration = null;
      });
    }
    default: {
      return state;
    }
  }
};

export default digitalDispatchTimerReducer;
